import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';
import { Account } from 'app/shared/models/account';
import { environment } from 'environments/environment';

@Component({
  selector: 'about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  logoLogin = environment.logoLogin;
  logoAlt = environment.logoAlt;

  accountInfo: Account;

  constructor(public dialogRef: MatDialogRef<AboutComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private privateService: PrivateService) { }

  ngOnInit(): void {
    this.privateService.getAccount().subscribe({
      next: res => {
        this.accountInfo = res;
      }
    })
  }

}
